module.exports = __webpack_public_path__ + "img/user-first-excellence.02764630.svg";